import React from "react";
import { MaskReveal } from "@/components/motion/MaskReveal";
import { Reveal } from "@/components/motion/Reveal";
import { useT } from "@/hooks/useT";

/**
 * Hero for /verified-documents.
 *
 * Two-line gradient-on-the-last-noun treatment:
 *   EN: "Verified by Frac." / "Sealed on [Bitcoin]."
 *   ZH: "Frac 发布," / "封存于 [比特币。]"
 *
 * The hero callout is tagged with the exact string `[LEGAL-REVIEW]` in a
 * JSX comment below so counsel can grep for every un-cleared sentence.
 */
export function Hero() {
  const { t } = useT("verifiedDocuments");

  return (
    <section
      className="relative pb-16 pt-24 md:pb-20 md:pt-32"
      data-testid="verified-hero"
    >
      <div className="mx-auto max-w-6xl px-6">
        <Reveal>
          <p className="mb-5 text-[12px] font-semibold uppercase tracking-caps text-eyebrow">
            {t("hero.eyebrow")}
          </p>
        </Reveal>
        <h1 className="font-sans text-[40px] font-bold leading-[1.05] tracking-tight sm:text-[48px] md:text-[61px]">
          <MaskReveal as="span" className="block">
            {t("hero.h1Line1")}
          </MaskReveal>
          <MaskReveal as="span" className="block" delay={120}>
            {`${t("hero.h1Line2")} `}
            <span
              className="inline-block align-baseline"
              style={{
                backgroundImage: "var(--gradient-brand)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              {t("hero.h1Line2Accent")}
            </span>
          </MaskReveal>
        </h1>
        <Reveal delay={280}>
          {/* [LEGAL-REVIEW] Hero callout — operator / counsel to approve
              before this route is linked from main nav or footer. */}
          <p
            className="mt-7 max-w-2xl text-lg leading-relaxed text-ink-secondary md:text-xl"
            data-testid="verified-hero-callout"
          >
            {t("hero.calloutLegalReview")}
          </p>
        </Reveal>
      </div>
    </section>
  );
}

export default Hero;
